import { match, useParams } from 'react-router-dom';
import '../../components/cms/CmsOfficeServices/OfficeServicesCmsPage.css';
import { Routing } from '../../components/Routes';
import { Config } from '../../config';
import { useRedirectOnError } from '../../hooks/useRedirectOnError';
import { PreloadedData, Res, fetchResourceMap, useCms } from '../../state/api';
import { CmsComponent, JsxArgs } from '../cms/CmsComponent';
import '../cms/CmsOfficeServices/OfficeServicesCmsPage.css';
import { Main } from '../Main/Main';
import { RedirectStatus } from '../RedirectStatus';
import './AboutCmsPage.css';
import './AccoCampaignCmsPage.css';
import './CmsPage.css';
import './HomeOfficeCmsPage.css';
import { LoaderPage } from './LoaderPage';
import { NotFoundPage } from './NotFoundPage';
import './TorkCampaignPage.css';

export const CmsPage = (): JSX.Element => {
	const { slug } = useParams<UrlParams>();
	const { data, error } = useCms(Res.cmsPage, { slug });
	const { redirect, notFound } = useRedirectOnError(error);

	if (redirect) return <RedirectStatus to={redirect.newUrl} status={redirect.code} />;
	if (notFound || (Array.isArray(data) && data.length === 0)) return <NotFoundPage />;
	if (!data) return <LoaderPage />;

	return (
		<Main>
			<div className="cms-page">
				<CmsComponent structure={data} />
			</div>
		</Main>
	);
};

const fetchSubcomponentData = async (config: Config, cmsStructure: JsxArgs) => {
	let fetchPromises: Promise<PreloadedData>[] = [];

	const traverseObject = ([_, props, ...children]: JsxArgs) => {
		if (!props) return;
		const { endpoint } = props;
		if (endpoint !== undefined) fetchPromises.push(fetchResourceMap(config, Res.cmsEndpoint, { endpoint }));
		for (var child of children) if (Array.isArray(child)) traverseObject(child);
	};

	traverseObject(cmsStructure);

	const settledPromises = await Promise.allSettled(fetchPromises);
	let subcomponentData: PreloadedData = {};
	for (var promise of settledPromises) {
		if (promise.status === 'fulfilled') {
			subcomponentData = { ...subcomponentData, ...promise.value };
		}
	}
	return subcomponentData;
};

export async function fetchCmsData(config: Config, slug: string): Promise<PreloadedData> {
	const cmsPageResponse = await fetchResourceMap(config, Res.cmsPage, { slug }, config.cmsContent);
	const key = Object.keys(cmsPageResponse)[0];
	const subcomponentData = await fetchSubcomponentData(config, cmsPageResponse[key] as JsxArgs);
	return { ...cmsPageResponse, ...subcomponentData };
}

type UrlParams = { slug: string };
export const cmsRouting: Routing<UrlParams> = {
	path(_urls) {
		return '/:slug([a-zA-Z0-9/_.-]+)';
	},
	component: CmsPage,
	requiresAuth: false,
	preload: async (config, routeMatch: match<UrlParams>, _query: string) => {
		const { slug } = routeMatch.params;
		return await fetchCmsData(config, slug);
	},
};
